import { useEffect, useMemo, useState } from "react";
import { createTheme } from "@mui/material/styles";

const getSystemTheme = () => (typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

export default function useAppTheme(initialMode = "light") {
  const [mode, setMode] = useState(initialMode === "system" ? getSystemTheme() : (initialMode === "dark" ? "dark" : "light"));

  useEffect(() => {
    if (initialMode === "system") {
      setMode(getSystemTheme());
      if (typeof window === "undefined" || !window.matchMedia) return undefined;
      const media = window.matchMedia("(prefers-color-scheme: dark)");
      const listener = (event) => setMode(event.matches ? "dark" : "light");
      media.addEventListener?.("change", listener);
      media.addListener?.(listener);
      return () => {
        media.removeEventListener?.("change", listener);
        media.removeListener?.(listener);
      };
    }
    setMode(initialMode === "dark" ? "dark" : "light");
    return undefined;
  }, [initialMode]);

  const colorMode = useMemo(() => ({
    setColorMode: (value) => setMode(value === "dark" ? "dark" : "light"),
    toggleColorMode: () => setMode((prev) => (prev === "light" ? "dark" : "light")),
  }), []);

  const theme = useMemo(() =>
    createTheme({
      palette: {
        mode,
        ...(mode === "light"
          ? {
              primary: { main: "#6b6b6b" },
              background: { default: "#f5f5f5", paper: "#fff" },
              text: { primary: "#000" },
            }
          : {
              primary: { main: "#b0b0b0" },
              background: { default: "#121212", paper: "#1e1e1e" },
              text: { primary: "#e0e0e0" },
            }),
      },
    }), [mode]);

  return { colorMode, theme, mode };
}
